import { render, staticRenderFns } from "./WithdrawalFormError.vue?vue&type=template&id=11b2731b&scoped=true&"
import script from "./WithdrawalFormError.vue?vue&type=script&lang=js&"
export * from "./WithdrawalFormError.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawalFormError.vue?vue&type=style&index=0&id=11b2731b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b2731b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
